import React from 'react'
import CommonBanner from "../components/Common Banner Component/HeroBanner"
import PlainText from '../components/PlainText/PlainText'
import OutsourcedCards from '../components/OutsourcedCards/OutsourcedCards'
import WhyChooseUs from '../components/WhyChooseUs/WhyChooseUs'
import ParallaxContent from '../components/ParallaxContent/ParallaxContent'
import FaqSection from '../components/FaqSection/FaqSection'
import { useNavigate } from 'react-router-dom'
import LetsGetStarted from '../components/LetsGetStarted/LetsGetStarted'
import PartnerCompanies from '../components/PartnerCompanies/PartnerCompanies'
import { Helmet } from 'react-helmet'

const VCSList = [
  "Financial planning & cash flow forecasting",
  "Budgeting & business performance analysis",
  "Investor & stakeholder financial reports",
  "Growth strategy & risk management",
  "Real-time decision support & KPI tracking",
]

const FSBList = [
"Daily, weekly, or monthly bookkeeping",
"Accounts payable & receivable management",
"Expense tracking & invoice processing",
"Bank & credit card reconciliations",
"General ledger maintenance & financial reporting",
]

const PHAList =[
"Payroll processing & tax remittances",
"Direct deposits & employee pay stubs",
"T4, T5, and ROE filings",
"WSIB, CPP, EI remittances",
"HR support for employee records & benefits administration",
]

const whosBenifitData = [
  {
    icon:"/images/icons/os-card-icon-1.svg",
    title:`<h4 class='color-white' style={{fontWeight:"700"}}>Startups &<br> Growing Businesses</h4> `,
    content:"Focus on scaling while we handle the financials."
  },
  {
    icon:"/images/icons/os-card-icon-2.svg",
    title:`<h4 class='color-white' style={{fontWeight:"700"}}>Small &<br> Medium Enterprises</h4> `,
    content:"Reliable support without an in-house team."
  },
  {
    icon:"/images/icons/os-card-icon-3.svg",
    title:`<h4 class='color-white' style={{fontWeight:"700"}}>E-Commerce &<br> Retail</h4> `,
    content:"Efficient bookkeeping & tax compliance for online sellers."
  },
  {
    icon:"/images/icons/os-card-icon-4.svg",
    title:`<h4 class='color-white' style={{fontWeight:"700"}}>Professional<br> Service Providers</h4> `,
    content:"Law firms, consultants, medical practices, and more."
  },
  {
    icon:"/images/icons/os-card-icon-5.svg",
    // title:`<h4 class='color-white' style={{fontWeight:"700"}}>Nonprofits &<br> Charities</h4> `,
    title:`<h4 class='color-white' style={{fontWeight:"700"}}>Real Estate & Construction</h4> `,
    content:"Project-based financial tracking and industry-specific compliance"
  },
]

const faqData = [
  {
    "title": "How do outsourced accounting services work?",
    "content": "We securely connect to your accounting systems in the cloud, then handle day-to-day bookkeeping, payroll, tax, and Virtual CFO tasks remotely. You receive real-time dashboards, monthly management reports, and on-demand advice from your dedicated CPA team."
  },
  {
    "title": "Can I customize the services to my business needs?",
    "content": "Yes. Choose any mix of Virtual CFO, bookkeeping, payroll, HR, or tax services. Packages are scalable, so you can add or remove services as your company grows."
  },
  {
    "title": "Will I still control my finances?",
    "content": "Always. You retain full access to your accounting platform and bank accounts. We provide accurate data and strategic insight; you make the final decisions."
  },
  {
    "title": "What industries do you specialize in?",
    "content": "Our CPAs serve tech startups, professional services, e-commerce, manufacturing, and other mid-market businesses across Canada. We tailor workflows and KPIs to each sector’s unique requirements."
  },
  {
    "title": "How does CPA oversight benefit me?",
    "content": "Every engagement is led by a Chartered Professional Accountant who reviews your books, ensures compliance, and delivers strategic guidance—reducing errors and strengthening decision-making."
  },
  {
    "title": "Which software do you use?",
    "content": "We’re tech-agnostic but commonly work with QuickBooks Online, Xero, Sage300, AS400, JD Edwards, Oracle, Dext, ADP, Payworks, and Plooto. We’ll integrate with your existing stack or recommend the best tools for automation and clarity."
  },
  {
    "title": "How quickly can we get started?",
    "content": "Most clients are fully onboarded within two to four weeks. We map your current processes, migrate any historical data, and set up reporting dashboards before the first month-end close."
  },
  {
    "title": "How are your fees structured?",
    "content": "We offer transparent, fixed monthly pricing based on transaction volume, service mix, and complexity—no surprise hourly bills. Custom quotes are provided after a free consultation."
  },
  {
    "title": "What if the CRA audits us?",
    "content": "Lotus Accounting’s CPAs handle all correspondence, supply the required documentation, and represent you throughout the audit, minimizing disruption to your business."
  }
]


function OutsourcedServices() {
  const navigate = useNavigate()
  return (
    <div>    
      <Helmet>
                <link rel="canonical" href="https://www.lotusaccounting.ca/outsourced-services" />
                 <title>
          Outsourced Accounting Services in Toronto | CPA Experts
        </title>
        <meta
          name='description'
          content='Outsource bookkeeping, payroll, Virtual CFO, and tax services in Toronto. Lotus Accounting’s CPA team delivers accurate, scalable, and cost-effective financial solutions.'>
        </meta>
              </Helmet>
        <CommonBanner
            subHeading=""
            Heading="Industry-Focused, CPA-Led Outsourced Accounting — Save Time, Reduce Costs, Elevate Accuracy"
            Paragraph="Unlock enterprise-level accuracy, insight, and cost efficiency—Virtual CFO to payroll—all managed by Lotus Accounting’s industry-specialized CPAs so your team can stay focused on growth."
            btnText=""
            bgImg="/images/creative/outsourced-hero-bg.jpg"
            btn={false}
            ConsultationBtn={true}
            smallHeading={true}
             showPartners={true}
        />
        <PartnerCompanies/>

        <PlainText/>

        {/* <ServicesTextContent
            heading={"Virtual CFO Services (Strategic Financial Leadership)"}
            content={""}
            img={'/images/creative/plane-black-hero.png'}
            shiftRow={true}
            bgColor={"white"}
            bulletList={VCSList}
            btnText={"Book a Consultation"}
            btnRef="/contact"
        />
        <ServicesTextContent
            heading={"Full-Service Bookkeeping (Your Books, Handled by Experts)"}
            content={""}
            img={'/images/creative/plane-black-hero.png'}
            shiftRow={false}
            bgColor={"white"}
            bulletList={FSBList}
            btnText={"Book a Consultation"}
            btnRef="/contact"
        />
        <ServicesTextContent
            heading={"Payroll & HR Administration (Seamless Payroll & Compliance)"}
            content={""}
            img={'/images/creative/plane-black-hero.png'}
            shiftRow={false}
            bgColor={"white"}
            bulletList={PHAList}
            btnText={"Book a Consultation"}
            btnRef="/contact"
        /> */}

        <OutsourcedCards/>

        <ParallaxContent/>
        
        <WhyChooseUs
          heading='Who Benefits from Our Services?'
          cardData={whosBenifitData}
          rowGridSize={4}
          doubledRow={true}
        />

        <FaqSection
            heading='Frequently Asked Questions (FAQs)'
            faqData={faqData}
            btn={true}
            btnText="Get a Free Consultation "
        />
        <div className='container mb-3 d-flex'>
          {/* <button className='blue-btn mx-auto ' onClick={()=>{navigate("/contact")}}>Get a Free Consultation </button> */}
          <button className='blue-btn mx-auto ' onClick={()=>{window.open("https://calendly.com/chandrancpa","blank")}}>Get a Free Consultation </button>
        </div>

        <LetsGetStarted
          heading="Take Your Business to the Next Level with Lotus Accounting!"
        />
   </div>
  )
}

export default OutsourcedServices